module.exports = __webpack_public_path__ + "static/media/green-red.ffd4819d.png";